/*
 * @Author: klcxkjhsm huangshimin@klcxkj.com
 * @Date: 2024-02-20 15:14:10
 * @LastEditors: klcxkjhsm huangshimin@klcxkj.com
 * @LastEditTime: 2025-03-27 20:02:33
 * @FilePath: \app-client-h5\src\pages\onlineService\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React, { Component } from 'react';
import YSF from '@neysf/qiyu-web-sdk';
import './index.scss';
export default class onlineService extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }
  componentDidMount() {
    // 上报用户信息
    // configUsr();
    console.log('在线客服-----------------------------------------------');
    const searchParams = new URLSearchParams(window.location.search)
    if (window.location.search) {
      let options = {
        companyName: searchParams.get('companyName'),
        projectName: searchParams.get('projectName')
      }
      let { telephone, userAccount } = JSON.parse(searchParams.get('myInfo'))
      YSF.init('ccf5b90173de2b11de739bc308d0395f', {}).then(ysf => {
        ysf('open');
        ysf('config', {
          uid: userAccount.userId,
          name: userAccount.name,
          email: null,
          mobile: telephone,
          level: 1, // vip级别
          data: JSON.stringify([
            { "key": "real_name", "value": "", hidden: false },
            { "key": "mobile_phone", "hidden": true, "value": telephone },
            { "key": "email", hidden: false, "value": "" },
            { "index": 0, "key": "accountId", "label": "账户ID", "value": userAccount.accountId, },
            { "index": 1, "key": "companyName", "label": "运营商名称", "value": options.companyName },
            { "index": 2, "key": "projectName", "label": "项目名称", "value": options.projectName },
          ])
        });
      }).catch(error => {
        console.log('sdk加载失败---', error);
      });
    } else {
      alert('网络连接错误')
    }
  }
  render() {
    return (
      <div className="m-main">
      </div>
    );
  }
}